import styled from 'styled-components';

export const TimeWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`;
